import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Card } from 'antd';
import AntDTable from "../AntDTable/AntDTable";
import BtnAdd from "../Commons/Buttons/BtnAdd";

function MedicationHistory() {
const [addDetails, setAddDetails] = useState([]);
const [showLoader, setShowLoader] = useState(false);
const [showDelete, setShowDelete] = useState(false);
const [showAppointment, setShowAppointment] = useState(false);
const [showEdit, setShowEdit] = useState(false);
const [showForm, setShowForm] = useState(false);
const [hasVitalSigns, setHasVitalSigns] = useState(false);
const [rows, setRows] = useState([]);
const data = [
  {
    key: '1',
    date: "8/15/2023",
    aog: 3,
    weight: 160,
    blood_pressure: 120,
    height: 178,
    heart_rate: 100,
    presentation: "",
    new: "test",
  },
  {
    key: '2',
    date: "8/16/2023",
    aog: 5,
    weight: 170,
    blood_pressure: 125,
    height: 178,
    heart_rate: 100,
    presentation: "",
    new: "test",
  },
  {
    key: '3',
    date: "8/17/2023",
    aog: 5,
    weight: 170,
    blood_pressure: 125,
    height: 178,
    heart_rate: 100,
    presentation: "",
    new: "test",
  },
];
function handleEditVitalSign() {
    setShowForm(true)
    setHasVitalSigns(false)
  }
function handleShowForm() {
    setShowForm(!showForm)
    setShowAppointment(false)
  }
  
  function handleShowAppointment() {
    setShowAppointment(!showAppointment)
    setShowForm(false)
  }
const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddDetails((prevState) => ({
    ...prevState,
    [name]: value,
    }));
}
const handleAddRow = () => {
    const newRow = {
      id: rows.length + 1,
      // Add other properties for your table cells
    };
    setRows([...rows, newRow]);
  };
  const handleDeleteRow = (id) => {
    const updatedRows = rows.filter(row => row.id !== id);
    setRows(updatedRows);
  };

return (
    <div>
      <Card 
        className="card-with-table mb-2"
        style={{ maxHeight: '500px', overflow: 'hidden' }}> 
          <label className="font-bold">Vaccination History</label>
          <div className="row align-wb-right pt-1">
              <div className="col-4">
                <BtnAdd
                    label={"ADD VACCINE"}
                    size={"sm"}
                    onClick={(e) => setShowForm(!showForm)}
                />
              </div>
          </div>
          <div className="row justify-content-left">
                <div className="col-sm-12 pt-4">
                    <AntDTable
                        tableHeaders={[
                            "Vaccine Name",
                            "1st Shot",
                            "2nd Shot",
                            "3rd Shot",
                            "4th Shot",
                        ]}
                        headerSelector={[
                            "gravida",
                            "year",
                            "weight_lb",
                            "weight_oz",
                        ]}
                        tableData={data}
                        // loading={showLoader}
                        isClickable={false}
                        withAction={false}
                        scroll={{ x: true }}
                    />
                </div>
            </div>

      </Card>
      <Card 
        className="card-with-table mb-2"
        style={{ maxHeight: '500px', overflow: 'hidden' }}> 
          <label className="font-bold">Maintenance Medication History</label>
          <div className="row align-wb-right pt-1">
              <div className="col-5">
                <BtnAdd
                    label={"ADD MAINTENANCE MEDICATION"}
                    size={"sm"}
                    onClick={(e) => setShowForm(!showForm)}
                />
              </div>
          </div>
          <div className="row justify-content-left card-table">
                <div className="col pt-4">
                    <AntDTable
                        tableHeaders={[
                            "Generic Name",
                            "Brand Name",
                            "Preparation",
                            "Form",
                            "Dosage",
                            "Frequency",
                            "Timing",
                            "Duration",
                            "Compliance",
                        ]}
                        headerSelector={[
                            "key",
                            "date",
                            "aog",
                            "weight",
                            "blood_pressure",
                            "height",
                            "heart_rate",
                            "presentation",
                            "new",
                           
                            
                        ]}
                        tableData={data}
                        // loading={showLoader}
                        isClickable={false}
                        withAction={false}
                        scroll={{ x: true }}
                    />
                </div>
            </div>

      </Card>
      <Card 
        className="card-with-table mb-2"
        style={{ maxHeight: '500px', overflow: 'hidden' }}> 
          <label className="font-bold">Medication History</label>
          <div className="row align-wb-right pt-1">
              <div className="col-4">
                <BtnAdd
                    label={"ADD MEDICATION"}
                    size={"sm"}
                    onClick={(e) => setShowForm(!showForm)}
                />
              </div>
          </div>
          <div className="row justify-content-left">
                <div className="col-sm-12 pt-4">
                    <AntDTable
                        tableHeaders={[
                            "Generic",
                            "Brand",
                            "Quantity",
                            "Preparation",
                            "Form",
                            "Dosage",
                            "Duration",
                        ]}
                        headerSelector={[
                            "gravida",
                            "year",
                            "weight_lb",
                            "weight_oz",
                        ]}
                        tableData={data}
                        // loading={showLoader}
                        isClickable={false}
                        withAction={false}
                        scroll={{ x: true }}
                    />
                </div>
            </div>

      </Card>
    </div>
);
}

export default MedicationHistory;
